import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NumberChangeAddClassModule } from 'src/app/shared/directive/number-change-add-class/number-change-add-class.module';
import { LifeObserveModule } from '../../directive/life-observe/life-observe.module';
import { LoadingModule } from '../../directive/loading/loading.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ImgCarouselModule } from '../img-carousel/img-carousel.module';
import { LazyImageComponent } from '../lazy-image/lazy-image.component';
import { GameUnitComponent } from './game-unit/game-unit.component';
import { LabelUnitComponent } from './label-unit/label-unit.component';
import { NewSwiperUnitComponent } from './new-swiper-unit.component';
import { ProviderUnitComponent } from './provider-unit/provider-unit.component';
import { SportUnitComponent } from './sport-unit/sport-unit.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    LoadingModule,
    LifeObserveModule,
    ImgCarouselModule,
    LazyImageComponent,
    NumberChangeAddClassModule,
  ],
  declarations: [
    NewSwiperUnitComponent,
    GameUnitComponent,
    ProviderUnitComponent,
    LabelUnitComponent,
    SportUnitComponent,
  ],
  exports: [NewSwiperUnitComponent, GameUnitComponent, ProviderUnitComponent, LabelUnitComponent],
})
export class NewSwiperUnitModule {}
